import {
  IPriorityLevelPayload,
  IPriorityLevelResponse,
  IPriorityLevelsResponse
} from 'types/priorityLevel';
import request from './index';
import toErrorWithMessage from 'utilities/getErrorMessage';

export const getPriorityLevels = () => {
  try {
    return request<IPriorityLevelsResponse>({
      options: {
        url: '/priority_levels',
        method: 'get'
      }
    });
  } catch (e) {
    return { data: [], pagination: {}, error: toErrorWithMessage(e) };
  }
};

export const getPriorityLevel = (id: number) => {
  try {
    return request<IPriorityLevelResponse>({
      options: {
        url: `/priority_levels/${id}`,
        method: 'get'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const createPriorityLevel = (data: IPriorityLevelPayload) => {
  try {
    return request<IPriorityLevelResponse>({
      options: {
        url: '/priority_levels',
        method: 'post',
        data
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const editPriorityLevel = (id: number, data: IPriorityLevelPayload) => {
  try {
    return request<IPriorityLevelResponse>({
      options: {
        url: `/priority_levels/${id}`,
        method: 'patch',
        data
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};

export const deletePriorityLevel = (id: number) => {
  try {
    return request<{}>({
      options: {
        url: `/priority_levels/${id}`,
        method: 'delete'
      }
    });
  } catch (e) {
    return { data: null, error: toErrorWithMessage(e) };
  }
};
